/***********************
 * INDEX TAB8 CONTENT (Open Requests)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
  Tooltip,
} from "reactstrap"

import "../datatables.scss"

//Excel export
import XLSX from "xlsx"

//Autotable PDF
import jsPDF from "jspdf"
import "jspdf-autotable"

//Locale
import { withTranslation } from "react-i18next"
import {
  dateFormatter,
  showToast,
  defaultPageSizeOptions,
  stringSorter,
  numberSorter,
} from "utils/general"
import { Table as AntdTable, Input as AntdInput } from "antd"
import { tableDefaultHeight } from "constants/layout"

const { Search } = AntdInput

const OpenRequestsReporting = props => {
  const [itemsLength, setItemsLength] = useState([0])
  //Table data state
  const [series, setSeries] = useState([])
  //Dropdown button state
  const [menu, setMenu] = useState(false)
  // Tooltip state for download button
  const [downloadstatstableTT, setDownloadstatstableTT] = useState(false)
  const [searchText, setSearchText] = useState("")

  // Handle search and set new state data when props.data changes
  useEffect(() => {
    if (props.activeTab == 8) {
      //console.log("Open Requests data changed: " + JSON.stringify(props.data))
      const delayDebounce = setTimeout(() => {
        const lower = searchText.toLowerCase()

        const filtered = props.data.list.filter(item => {
          const dateText = dateFormatter(item.date) || ""
          const visitor = item.visitor?.toLowerCase() || ""
          const client = item.client_name?.toLowerCase() || ""
          const group = item.group?.toLowerCase() || ""

          return (
            dateText.includes(lower) ||
            visitor.includes(lower) ||
            client.includes(lower) ||
            group.includes(lower)
          )
        })
        setSeries(filtered)
        setItemsLength(filtered.length)
        //console.log("Open Requests filter changed: ", filtered)
      }, 300)

      return () => clearTimeout(delayDebounce)
    }
  }, [searchText, props.data])

  //Excel and pdf name
  const title = props.t("Open requests")

  // Table structure
  const columns = [
    {
      dataIndex: "date",
      title: props.t("Time"),
      defaultSortOrder: "descend",
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["date"], b["date"], sortOrder)
      },
      render: dateFormatter,
      width: "180px",
    },
    {
      dataIndex: "client_name",
      title: props.t("Customers name"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "client_name", sortOrder)
      },
      width: "180px",
    },
    {
      dataIndex: "group",
      title: props.t("Group"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "group", sortOrder)
      },
      width: "180px",
    },
    {
      dataIndex: "visitor",
      title: props.t("Visitor"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "visitor", sortOrder)
      },
      width: "180px",
    },
  ]

  // Export PDF table
  const exportPDF = () => {
    let message = props.t("PDF file exported succesfully!")
    const unit = "pt"
    const size = "A4" // Use A1, A2, A3 or A4
    const orientation = "landscape" // portrait or landscape
    const theme = "grid" //striped,  plain

    const marginLeft = 40
    const doc = new jsPDF(orientation, unit, size, theme)

    doc.setFontSize(14)

    const data = series.map(elt => [
      dateFormatter(elt.date),
      elt.client_name,
      elt.group,
      elt.visitor,
    ])

    let content = {
      startY: 50,
      head: [
        [
          props.t("Time"),
          props.t("Customers name"),
          props.t("Group"),
          props.t("Visitor"),
        ],
      ],
      body: data,
    }

    doc.text(title, marginLeft, 40)
    doc.autoTable(content)
    doc.save(title + ".pdf")

    //Show toast
    showToast(message, "success", 5000, "toast-bottom-left")
  }

  // Creating Excel workbook+worksheet+download
  const downloadExcel = () => {
    let message = props.t("Excel file exported succesfully!")
    const wb = XLSX.utils.book_new()

    const Heading = [
      [
        props.t("Time"),
        props.t("Customers name"),
        props.t("Group"),
        props.t("Visitor"),
      ],
    ]
    const data = series.map(elt => [
      dateFormatter(elt.date),
      elt.client_name,
      elt.group,
      elt.visitor,
    ])

    // creating sheet and adding data from 2nd row of column A.
    // Leaving first row to add Heading
    const ws = XLSX.utils.json_to_sheet(data, {
      origin: "A2",
      skipHeader: true,
    })
    XLSX.utils.sheet_add_aoa(ws, Heading, { origin: "A1" })
    XLSX.utils.book_append_sheet(wb, ws, title)
    XLSX.write(wb, { bookType: "xlsx", type: "buffer" })
    XLSX.writeFile(wb, title + " (" + new Date() + ")" + ".xlsx")

    //Show toast
    showToast(message, "success", 5000, "toast-bottom-left")
  }

  return (
    <>
      {/* Setting filter for view */}
      <Row className=" mt-0 mb-2">
        <div className="d-flex flex-wrap">
          <span>
            <h5 className="mt-0">{props.t("Open requests")}</h5>
          </span>
        </div>
      </Row>
      <Row>
        <Col lg="3">
          <Card>
            <CardBody>
              <Col className="mt-2 mb-4 text-center" xs="12">
                <div className="mb-1 ">
                  <div className="mb-4">
                    <i className="mdi mdi-home-map-marker text-primary display-6" />
                  </div>
                  <div className="mt-2 mb-2">
                    <h3>{itemsLength}</h3>
                    <p className="">{props.t("Open requests")}</p>
                  </div>
                </div>
              </Col>{" "}
            </CardBody>
          </Card>
        </Col>{" "}
        <Col lg="9">
          <Card className="">
            <CardBody className="pb-0">
              <Row>
                <Col className="col-12">
                  <React.Fragment>
                    <Row className="align-items-center justify-content-end">
                      <Col className="col-auto">
                        <Search
                          placeholder={props.t("Search")}
                          allowClear
                          value={searchText}
                          onChange={e => setSearchText(e.target.value)}
                          style={{ width: "180px" }}
                        />
                      </Col>
                      <Col className="col-auto">
                        <span className="mt-0">
                          <Tooltip
                            placement="bottom"
                            isOpen={downloadstatstableTT}
                            target="downloadstatstable"
                            toggle={() => {
                              setDownloadstatstableTT(!downloadstatstableTT)
                            }}
                          >
                            {props.t("Download statistics")}
                          </Tooltip>
                          <Dropdown
                            id="printButtonServicesStats"
                            isOpen={menu}
                            toggle={() => setMenu(!menu)}
                            className="download-btn text-center"
                            type="button"
                          >
                            <DropdownToggle
                              id="downloadstatstable"
                              className="text-muted"
                              tag="i"
                            >
                              <i className="mdi mdi-download " />
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => downloadExcel()}>
                                {props.t("Download .xlsx")}
                              </DropdownItem>
                              <DropdownItem onClick={() => exportPDF()}>
                                {props.t("Download .pdf")}
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </span>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col xl="12">
                        <AntdTable
                          className="light-header-table table align-middle table-nowrap mb-0"
                          bordered={false}
                          size="small"
                          rowKey={"id"}
                          columns={columns}
                          dataSource={series}
                          pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: defaultPageSizeOptions,
                          }}
                          tableLayout="auto"
                          scroll={{
                            x: "max-content",
                            y: tableDefaultHeight,
                          }}
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

OpenRequestsReporting.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  activeTab: PropTypes.any,
}

export default withTranslation()(OpenRequestsReporting)
